export default __webpack_public_path__ + "static/media/copyIcon.3475ff19.svg";